// routes/forgot-password.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/forgot-password')

export const handle = { name: 'forgot-password' }

export default dynamic(getClientModule, { ssr: false })
